import { render } from "./rswt.vue?vue&type=template&id=168870d9"
import script from "./rswt.vue?vue&type=script&lang=js"
export * from "./rswt.vue?vue&type=script&lang=js"

import "./rswt.vue?vue&type=style&index=0&id=168870d9&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__